import React from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";

import moment from 'moment';

import Helmet from "react-helmet";
import CheckCircle from "@mui/icons-material/CheckCircle";
import ClickAwayListener from '@mui/material/ClickAwayListener';
import CachedIcon from '@mui/icons-material/Cached';

import { red, green, blue } from "@mui/material/colors";
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import { withStyles } from '@mui/styles';
import { getChipVariant } from '../../utils/chipStyles';
import { complaintRowDueYmd } from "modules/complaints/utils/complaintResponseDue";

import {
  Checkbox, Box, IconButton, Link, Breadcrumbs as MuiBreadcrumbs, Divider as MuiDivider, Paper as MuiPaper, Table, TableBody, TableContainer, TableCell,
  TableHead, TablePagination, Chip, TableRow, TableSortLabel, Toolbar, Tooltip, Typography, FormControlLabel, Switch, Menu, MenuItem, TextField as MuiTextField, Button as MuiButton,
  FormControl, InputLabel, Select, Input,
} from "@mui/material";




import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

import CurrencyTextField from '../Inputs/CurrencyTextField'

import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterList";
import LoopIcon from "@mui/icons-material/Loop";
import Check from "@mui/icons-material/Check";
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import EditIcon from '@mui/icons-material/Edit';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import DescriptionIcon from '@mui/icons-material/Description';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import EvStationIcon from '@mui/icons-material/EvStation';
import PrintIcon from '@mui/icons-material/Print';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import InsertDriveFileOutlinedIcon  from '@mui/icons-material/InsertDriveFileOutlined';

import { spacing } from "@mui/system";
import { dateFormatter, dateFormatterNoTime, dateTime, formatMoney, txtBoxDateFormatter, formatPhoneNumber } from "../../setup/helpers";

import {
  BrowserRouter as Router,
  Route,
  Navigate,
  useNavigate,
  useLocation
} from "react-router-dom";

// Types i initially plan to support: 
// text, number, checkBox, date

const Button = styled(MuiButton)(spacing);
const TextField = styled(MuiTextField)(spacing);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


export function EditableTableRow({
  currentObject, fieldTitles, fieldTypes, fieldNames,
  handleRowClick, handleRowSelected,
  isItemSelected, handleStandardItemChange,
  dropDownFields,
  globalIndex,
  readOnly,
  conditionalStyle,
  onChangeFields,
  urlFields,
  handlePreviewClick,
  handleGenerateClick,
  handleResetBatchBillingClick,
  popupModelFields,
  showNumber,
  markItemAsEdited,
  hideRowFieldTitles = false,
  isDenseTable = false,
  itemSaveOnTextboxLeave = false,
  inputSize = "medium", // Optional prop: "small" | "medium" for input/select size
  cellVerticalAlign, // Optional prop: "top" to align cell content to top, default is middle
}) {


  const useStyles = makeStyles((theme) => ({
    tableCell: {
      padding: "14px"
    },
    rowNumberTableCell: {
      paddingRight: "14px"
    },
  }));

  const navigate = useNavigate();
  const navTo = (page) => navigate(page);
  const [customOnChangeFields, setOnChangeFields] = React.useState(onChangeFields);
  const [customUrlFields, setUrlFields] = React.useState(urlFields);
  const [rowObject, setRowObject] = React.useState(Object.assign({}, currentObject));
  const classes = useStyles();

  const [cellPoppedUp, setPoppedUpCell] = React.useState(null);

  const passedGlobalIndex = globalIndex || 0;
  const HandleRowSelected = () => {
    handleRowSelected(currentObject);
  }

  const HandlePreviewClicked = () => {
    handlePreviewClick(currentObject);
  }

  const HandleGenerateClicked = () => {
    handleGenerateClick(currentObject);
  }

  const HandleResetBatchBillingClicked = () => {
    if (handleResetBatchBillingClick) {
      handleResetBatchBillingClick(currentObject);
    }
  }


  const HandleRowClick = () => {
    handleRowClick(currentObject);
  }

  const showFieldPopupClick = (fieldName) => {
    setPoppedUpCell(fieldName);
  };

  const hideFieldPopupClick = (fieldName) => {
    setPoppedUpCell(null);
  };

  // For a checkbox that contains a true or false, just set the value to the opposite of itself
  const HandleRowPropertyToggled = (event) => {
    currentObject[event.target.name] = !currentObject[event.target.name];
    if (handleStandardItemChange) {
      handleStandardItemChange(currentObject);
    }
  }

  const onFieldChange = (event) => {
    // Gets the current vendor info data and updates it with the event's name and value:
    if (event.target.type == "number") {
      if (event.target.value.length == 0) {
        currentObject[event.target.name] = Number(0);
      }
      else {
        currentObject[event.target.name] = Number(event.target.value);
      }
    }
    else {
      currentObject[event.target.name] = event.target.value;
    }
    if (markItemAsEdited) {
      markItemAsEdited(currentObject);
    }
  }

  const HandleTextBoxDisselect = (event) => {
    if (event.target.value != rowObject[event.target.name]) {
      onFieldChange(event);
      if (customOnChangeFields && customOnChangeFields.length > 0) {
        let onChangeFieldCustomMethod = customOnChangeFields.find(obj => {
          return obj.targetFieldName === event.target.name
        });
        if (onChangeFieldCustomMethod) {
          var newRowObject = onChangeFieldCustomMethod.method(currentObject);
          currentObject = newRowObject;
        }
        if (handleStandardItemChange) {
          handleStandardItemChange(currentObject);
        }
      }
      else if (itemSaveOnTextboxLeave) {
        if (handleStandardItemChange) {
          handleStandardItemChange(currentObject);
        }
      }
      setRowObject(Object.assign({}, currentObject));
    }
  }

  const HandleLabelPageUrlSelection = (fieldName) => {
    if (customUrlFields && customUrlFields.length > 0) {
      let customUrlField = customUrlFields.find(obj => {
        return obj.targetFieldName === fieldName
      });
      if (customUrlField) {
        var customURL = customUrlField.method(currentObject);
        if (customURL != null && !customURL.includes("notfound")) {
          window.open(customURL);
        }
      }
    }
  };


  /////////////////////////////////////////////////////////
  // All of the editable field types:
  const EditableNumberField = ({ fieldName, fieldTitle }) => {
    // Check for field-level validation errors
    const fieldErrors = currentObject._fieldErrors || {};
    const hasError = fieldErrors[fieldName];

    return (
      <TextField
        onChange={onFieldChange}
        label={fieldTitle}
        type="number"
        fullWidth
        size={inputSize}
        onBlur={HandleTextBoxDisselect}
        name={fieldName}
        defaultValue={currentObject[fieldName]}
        error={!!hasError}
        InputLabelProps={{
          shrink: true,
        }}
        sx={{
          my: 0,
          '& .MuiInputBase-root': {
            alignItems: 'center',
          },
        }}
      />
    )
  };
  const EditableMoneyField = ({ fieldName, fieldTitle }) => {
    return (
      <CurrencyTextField
        onChange={onFieldChange}
        label={fieldTitle}
        name={fieldName}
        onBlur={HandleTextBoxDisselect}
        variant="standard"
        defaultValue={currentObject[fieldName]}
        currencySymbol="$"
        //minimumValue="0"
        outputFormat="number"
        decimalCharacter="."
        digitGroupSeparator=","
      />
    )
  };
  const EditableDateField = ({ fieldName, fieldTitle }) => {
    // Check for field-level validation errors
    const fieldErrors = currentObject._fieldErrors || {};
    const hasError = fieldErrors[fieldName];

    return (
      <TextField
        onChange={onFieldChange}
        label={fieldTitle}
        type="date"
        fullWidth
        size={inputSize}
        name={fieldName}
        onBlur={HandleTextBoxDisselect}
        defaultValue={txtBoxDateFormatter(currentObject[fieldName])}
        error={!!hasError}
        InputLabelProps={{
          shrink: true,
        }}
        sx={{
          my: 0,
          '& .MuiInputBase-root': {
            alignItems: 'center',
          },
        }}
      />
    )
  };
  const EditableDateFieldPopupSmall = ({ fieldName, fieldTitle }) => {
    return (
      <>
        <Typography button component={'span'} variant="caption" name={fieldName} onClick={() => {
          showFieldPopupClick(fieldName)
        }}>
          {dateFormatter(currentObject[fieldName])}
        </Typography>
        <Dialog
          open={cellPoppedUp == fieldName ? true : false}
          TransitionComponent={Transition}
          fullWidth={"sm"}
          maxWidth={"sm"}
          keepMounted
          onClose={hideFieldPopupClick}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">{fieldTitle}</DialogTitle>
          <DialogContent>
            <TextField
              onBlur={(event) => {
                hideFieldPopupClick();
                HandleTextBoxDisselect(event);
              }}
              label={fieldTitle}
              type="date"
              fullWidth
              size={inputSize}
              name={fieldName}
              my={3}
              defaultValue={txtBoxDateFormatter(currentObject[fieldName])}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </DialogContent>
        </Dialog>

      </>
    )
  };
  const EditableNumberFourDecimalLimitField = ({ fieldName, fieldTitle }) => {
    return (
      <TextField
        onChange={onFieldChange}
        label={fieldTitle}
        type="number"
        fullWidth
        size={inputSize}
        name={fieldName}
        onBlur={HandleTextBoxDisselect}
        defaultValue={currentObject[fieldName].toFixed(4)}
        InputLabelProps={{
          shrink: true,
        }}
        sx={{
          my: 0,
          '& .MuiInputBase-root': {
            alignItems: 'center',
          },
        }}
      />
    )
  };
  const EditableTextField = ({ fieldName, fieldTitle }) => {
    // Check for field-level validation errors
    const fieldErrors = currentObject._fieldErrors || {};
    const hasError = fieldErrors[fieldName];

    return (
      <TextField
        onChange={onFieldChange}
        name={fieldName}
        label={fieldTitle}
        type="text"
        fullWidth
        size={inputSize}
        onBlur={HandleTextBoxDisselect}
        defaultValue={currentObject[fieldName]}
        error={!!hasError}
        InputLabelProps={{
          shrink: true,
        }}
        sx={{
          my: 0,
          '& .MuiInputBase-root': {
            alignItems: 'center',
          },
        }}
      />
    )
  };
  const TableLblField = ({ fieldName, fieldTitle }) => {
    // Check if this is a status field with Active/Inactive values
    if (currentObject[fieldName] === "Active") {
      return (
        <Chip
          label="Active"
          variant="outlined"
          size="small"
          style={{
            backgroundColor: "rgba(76, 175, 80, 0.1)",
            color: "#4caf50",
            border: "1px solid #4caf50",
            fontWeight: 500,
            borderRadius: "16px",
            fontSize: "0.875rem"
          }}
        />
      );
    } else if (currentObject[fieldName] === "Inactive") {
      return (
        <Chip
          label="Inactive"
          variant="outlined"
          size="small"
          style={{
            backgroundColor: "rgba(255, 193, 7, 0.1)",
            color: "#ff9800",
            border: "1px solid #ff9800",
            fontWeight: 500,
            borderRadius: "16px",
            fontSize: "0.875rem"
          }}
        />
      );
    }
    
    // Default rendering for non-status fields
    return (
      <Typography component={'span'} name={fieldName} onClick={() => HandleLabelPageUrlSelection(fieldName)}>
        {currentObject[fieldName]}
      </Typography>
    )
  };
  const ButtonLinkField = ({ fieldName, fieldTitle }) => {
    return (
      <div>
        {(currentObject[fieldName] && currentObject[fieldName].indexOf("notfound") == -1) &&
          <Button target="_blank" href={currentObject[fieldName]} color="primary">
            <InsertDriveFileIcon />
          </Button>
        }
      </div>
    )
  };

  const LeaseLightIcon = ({ fieldName, fieldTitle }) => {
    return (
      <div>
        {currentObject[fieldName] == 1 &&
          <Tooltip title="Lease Light. Keep Usage at 0.">
            <LightbulbIcon />
          </Tooltip>
        }
      </div>
    )
  };
  const EvMeterIcon = ({ fieldName, fieldTitle }) => {
    return (
      <div>
        {currentObject[fieldName] == 1 &&
        <Tooltip title="EV Meter">
            <EvStationIcon />
        </Tooltip>}
      </div>
    )
  }

  const PreviewButtonField = () => {
    return (
      <div>
        <Tooltip title="Preview">
          <Button size="small" onClick={() => HandlePreviewClicked()} color="primary">
            <DescriptionIcon />
          </Button>
        </Tooltip>
      </div>
    )
  };

  const BillPdfButtonField = () => {

    if(currentObject?.type?.toUpperCase() == "LATEFEE")
    return (
      <Tooltip title="Late fee generated">
      <Button size="small" color="primary">
        <MoneyOffIcon />
      </Button>
    </Tooltip>
    )

    if(currentObject?.url?.toLowerCase()?.includes("notfound"))
    return (
      <Tooltip title="Generate PDF">
      <Button size="small" onClick={() => HandleGenerateClicked()} color="danger">
         <p>Print Error</p>
        <CachedIcon style={{color: "#ff0000"}} />
      </Button>
    </Tooltip>
    )
    else
      return (
        <div>
          <Tooltip title="Preview">
            <Button size="small" onClick={() => HandlePreviewClicked()} color="primary">
              <DescriptionIcon />
            </Button>
          </Tooltip>
        </div>
      )
  };

  const SitePlanPdfButtonField = () => {
    const handlePreviewClick = (event) => {
      event.stopPropagation();
      window.open(currentObject.sitePlanSignedUrl, '_blank');
    };

    if (!currentObject?.sitePlans) {
      return (
        <div>
          <Tooltip title="No site plan uploaded">
            <div>
              <Button disabled color={'primary'}>
                <InsertDriveFileOutlinedIcon/>
              </Button>
            </div>
          </Tooltip>
        </div>
      )
    }

    return (
      <div>
        <Tooltip title="Preview">
          <Button
            size="small"
            onClick={handlePreviewClick}
            color="primary"
          >
            <DescriptionIcon/>
          </Button>
        </Tooltip>
      </div>
    )
  };


  const EditButtonField = () => {
    return (
      <div>
        <Tooltip title="Edit">
          <Button size="small" onClick={(e) => { e.stopPropagation(); HandlePreviewClicked(); }} color="primary">
            <EditIcon />
          </Button>
        </Tooltip>
      </div>
    )
  };

  // Reset Batch Billing button. Always rendered; only enabled when the row
  // represents a BillingBatchSet stuck in status = "In Progress" with no
  // batchJob assigned. When disabled, a tooltip explains why.
  const ResetBatchBillingButtonField = () => {
    const status = currentObject?.status;
    const batchJob = currentObject?.batchJob;
    const isResettable = status === 'In Progress' && (batchJob == null || batchJob === '');

    const tooltipText = isResettable
      ? "Reset this stuck billing batch"
      : "Only available when status is 'In Progress' and batchJob is empty";

    const handleClick = (event) => {
      event.stopPropagation();
      HandleResetBatchBillingClicked();
    };

    return (
      <div>
        <Tooltip title={tooltipText}>
          <span>
            <Button
              size="small"
              variant="outlined"
              color="warning"
              disabled={!isResettable}
              onClick={handleClick}
            >
              Reset Batch Billing
            </Button>
          </span>
        </Tooltip>
      </div>
    );
  };

  const WorkOrderStatusField = ({ fieldName, fieldTitle }) => {
    const status = currentObject[fieldName];
    
    if (status == "Closed") {
      return (
        <Chip
          label="Closed"
          variant="outlined"
          size="small"
          style={{
            backgroundColor: "rgba(76, 175, 80, 0.1)",
            color: "#4caf50",
            border: "1px solid #4caf50",
            fontWeight: 500,
            borderRadius: "16px",
            fontSize: "0.875rem"
          }}
        />
      );
    }
    else if (status == "Open") {
      return (
        <Chip
          label="Open"
          variant="outlined"
          size="small"
          style={{
            backgroundColor: "rgba(33, 150, 243, 0.1)",
            color: "#2196f3",
            border: "1px solid #2196f3",
            fontWeight: 500,
            borderRadius: "16px",
            fontSize: "0.875rem"
          }}
        />
      );
    }
    else if (status == "New") {
      return (
        <Chip
          label="New"
          variant="outlined"
          size="small"
          style={{
            backgroundColor: "rgba(255, 152, 0, 0.1)",
            color: "#ff9800",
            border: "1px solid #ff9800",
            fontWeight: 500,
            borderRadius: "16px",
            fontSize: "0.875rem"
          }}
        />
      );
    }
    else if (status == "Pending") {
      return (
        <Chip
          label="Pending"
          variant="outlined"
          size="small"
          style={{
            backgroundColor: "rgba(255, 193, 7, 0.1)",
            color: "#ffc107",
            border: "1px solid #ffc107",
            fontWeight: 500,
            borderRadius: "16px",
            fontSize: "0.875rem"
          }}
        />
      );
    }
    else {
      return (
        <Chip
          label={status}
          variant="outlined"
          size="small"
          style={{
            backgroundColor: "rgba(158, 158, 158, 0.1)",
            color: "#757575",
            border: "1px solid #bdbdbd",
            fontWeight: 500,
            borderRadius: "16px",
            fontSize: "0.875rem"
          }}
        />
      );
    }
  };


  const TableLblDateFieldDueDate = ({ fieldName, fieldTitle }) => {
    let date = new Date(currentObject[fieldName]);
    let now = Date.now();
    var offset = new Date().getTimezoneOffset();
    let str = moment(date).add(offset, "minutes").format("L");
    
    if (now > date && (currentObject['description'] != "Closed")) {
      // Overdue - Red chip
      return (
        <Chip
          label={`SLA Breached: ${dateFormatter(currentObject[fieldName])}`}
          variant="outlined"
          size="small"
          style={{
            backgroundColor: "rgba(244, 67, 54, 0.1)",
            color: "#f44336",
            border: "1px solid #f44336",
            fontWeight: 500,
            borderRadius: "16px",
            fontSize: "0.875rem"
          }}
        />
      );
    }
    else {
      // Normal due date - Neutral chip
      return (
        <Chip
          label={dateFormatter(currentObject[fieldName])}
          variant="outlined"
          size="small"
          onClick={() => HandleLabelPageUrlSelection(fieldName)}
          style={{
            backgroundColor: "rgba(158, 158, 158, 0.1)",
            color: "#757575",
            border: "1px solid #bdbdbd",
            fontWeight: 500,
            borderRadius: "16px",
            fontSize: "0.875rem",
            cursor: "pointer"
          }}
        />
      );
    }
  };

  const ComplaintSlaChipField = ({ fieldName, fieldTitle }) => {
    const state = currentObject.slaState || "ok";
    const dueYmd = complaintRowDueYmd(currentObject);

    const neutralStyle = {
      backgroundColor: "rgba(158, 158, 158, 0.1)",
      color: "#757575",
      border: "1px solid #bdbdbd",
      fontWeight: 500,
      borderRadius: "16px",
      fontSize: "0.875rem",
    };

    if (state === "completed") {
      return (
        <Chip label="—" variant="outlined" size="small" style={neutralStyle} />
      );
    }

    if (state === "overdue") {
      return (
        <Chip
          label={
            dueYmd ? `SLA Breached: ${dueYmd}` : currentObject.slaLabel || "Overdue"
          }
          variant="outlined"
          size="small"
          style={{
            backgroundColor: "rgba(244, 67, 54, 0.1)",
            color: "#f44336",
            border: "1px solid #f44336",
            fontWeight: 500,
            borderRadius: "16px",
            fontSize: "0.875rem",
          }}
        />
      );
    }

    if (state === "warning") {
      return (
        <Chip
          label={
            dueYmd
              ? `Due: ${dueYmd}`
              : currentObject.slaLabel || "Warning"
          }
          variant="outlined"
          size="small"
          style={{
            backgroundColor: "rgba(255, 193, 7, 0.1)",
            color: "#ffc107",
            border: "1px solid #ffc107",
            fontWeight: 500,
            borderRadius: "16px",
            fontSize: "0.875rem",
          }}
        />
      );
    }

    return (
      <Chip
        label={dueYmd || currentObject.slaLabel || "—"}
        variant="outlined"
        size="small"
        style={neutralStyle}
      />
    );
  };

  /** Same palette as WorkOrderStatusField for complaint workflow statuses */
  const ComplaintStatusChipField = ({ fieldName, fieldTitle }) => {
    const status = (currentObject[fieldName] || "").toString().trim();
    const chipOutline = (
      lbl,
      { bg, fg, border }
    ) => (
      <Chip
        label={lbl}
        variant="outlined"
        size="small"
        style={{
          backgroundColor: bg,
          color: fg,
          border: `1px solid ${border}`,
          fontWeight: 500,
          borderRadius: "16px",
          fontSize: "0.875rem",
        }}
      />
    );

    if (!status) {
      return chipOutline("—", {
        bg: "rgba(158, 158, 158, 0.1)",
        fg: "#757575",
        border: "#bdbdbd",
      });
    }

    const u = status.toUpperCase();
    if (u === "COMPLETED" || u === "CLOSED") {
      return chipOutline(status === "CLOSED" ? "Closed" : status, {
        bg: "rgba(76, 175, 80, 0.1)",
        fg: "#4caf50",
        border: "#4caf50",
      });
    }
    if (u === "OPEN") {
      return chipOutline(status, {
        bg: "rgba(33, 150, 243, 0.1)",
        fg: "#2196f3",
        border: "#2196f3",
      });
    }
    if (u === "NEW") {
      return chipOutline("New", {
        bg: "rgba(255, 152, 0, 0.1)",
        fg: "#ff9800",
        border: "#ff9800",
      });
    }
    if (u === "PENDING") {
      return chipOutline("Pending", {
        bg: "rgba(255, 193, 7, 0.1)",
        fg: "#ffc107",
        border: "#ffc107",
      });
    }

    return chipOutline(status, {
      bg: "rgba(158, 158, 158, 0.1)",
      fg: "#757575",
      border: "#bdbdbd",
    });
  };

  const TablePhoneLblFieldSmall = ({ fieldName, fieldTitle }) => {
    return (
      <Typography component={'span'} variant="caption" name={fieldName} onClick={() => HandleLabelPageUrlSelection(fieldName)}>
        {formatPhoneNumber(currentObject[fieldName])}
      </Typography>
    )
  };
  const TablePhoneLblField = ({ fieldName, fieldTitle }) => {
    return (
      <Typography component={'span'} name={fieldName} onClick={() => HandleLabelPageUrlSelection(fieldName)}>
        {formatPhoneNumber(currentObject[fieldName])}
      </Typography>
    )
  };

  const TableDateLblFieldSmall = ({ fieldName, fieldTitle }) => {
    return (
      <Typography component={'span'} variant="caption" name={fieldName} onClick={() => HandleLabelPageUrlSelection(fieldName)}>
        {dateFormatter(currentObject[fieldName])}
      </Typography>
    )
  };
  const TableLblFieldSmall = ({ fieldName, fieldTitle }) => {
    // Check if this is a status field with Active/Inactive values
    if (currentObject[fieldName] === "Active") {
      return (
        <Chip
          label="Active"
          variant="outlined"
          size="small"
          style={{
            backgroundColor: "rgba(76, 175, 80, 0.1)",
            color: "#4caf50",
            border: "1px solid #4caf50",
            fontWeight: 500,
            borderRadius: "16px",
            fontSize: "0.875rem"
          }}
        />
      );
    } else if (currentObject[fieldName] === "Inactive") {
      return (
        <Chip
          label="Inactive"
          variant="outlined"
          size="small"
          style={{
            backgroundColor: "rgba(255, 193, 7, 0.1)",
            color: "#ff9800",
            border: "1px solid #ff9800",
            fontWeight: 500,
            borderRadius: "16px",
            fontSize: "0.875rem"
          }}
        />
      );
    }
    
    // Default rendering for non-status fields
    return (
      <Link variant="body2" component={'span'} name={fieldName} onClick={() => HandleLabelPageUrlSelection(fieldName)}>
        {currentObject[fieldName]}
      </Link>
    )
  };
  const TableLblFieldBold = ({ fieldName, fieldTitle }) => {
    return (
      <Typography component={'span'} style={{ fontWeight: "bold" }} name={fieldName} onClick={() => HandleLabelPageUrlSelection(fieldName)}>
        {currentObject[fieldName]}
      </Typography>
    )
  };
  const TableLblFieldFourDecimalRounded = ({ fieldName, fieldTitle }) => {
    let value = "";
    let amount = currentObject[fieldName];
    try {
      let decimalCount = 4;
      const negativeSign = amount < 0 ? "-" : "";

      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;

      value = negativeSign + (j ? i.substr(0, j) + ',' : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + ',') + (decimalCount ? '.' + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
      console.log(e)
    }
    return (
      <Typography component={'span'} name={fieldName} onClick={() => HandleLabelPageUrlSelection(fieldName)}>
        {value}
      </Typography>
    )
  };
  const TableLblMoneyFourDecimal = ({ fieldName, fieldTitle }) => {
    return (
      <Typography component={'span'} name={fieldName} onClick={() => HandleLabelPageUrlSelection(fieldName)}>
        {formatMoney(currentObject[fieldName], 4)}
      </Typography>
    )
  };
  const TableLblDateField = ({ fieldName, fieldTitle }) => {
    return (
      <Typography component={'span'} name={fieldName} onClick={() => HandleLabelPageUrlSelection(fieldName)}>
        {dateFormatter(currentObject[fieldName])}
      </Typography>
    )
  };
  const TableLblDateNoTimeField = ({ fieldName, fieldTitle }) => {
    return (
      <Typography component={'span'} name={fieldName} onClick={() => HandleLabelPageUrlSelection(fieldName)}>
        {dateFormatterNoTime(currentObject[fieldName])}
      </Typography>
    )
  };
  const TableLblDateTimeField = ({ fieldName, fieldTitle }) => {
    return (
      <Typography component={'span'} name={fieldName} onClick={() => HandleLabelPageUrlSelection(fieldName)}>
        {dateTime(currentObject[fieldName])}
      </Typography>
    )
  };
  const TableLblMoneyField = ({ fieldName, fieldTitle }) => {
    return (
      <Typography component={'span'} name={fieldName} onClick={() => HandleLabelPageUrlSelection(fieldName)}>
        {currentObject[fieldName] != "N/A" ?
          formatMoney(currentObject[fieldName])
          :
          currentObject[fieldName]
        }
      </Typography>
    )
  };

  const StatusTagField = ({ fieldName, fieldTitle }) => {
    const theme = useTheme();
    const status = currentObject[fieldName];
    
    // Map status values to semantic chip types
    let chipType;
    switch(status?.toLowerCase()) {
      case 'active':
        chipType = 'success';
        break;
      case 'inactive':
        chipType = 'warning';
        break;
      case 'revoked':
        chipType = 'error';
        break;
      default:
        chipType = 'default';
    }
    
    const chipProps = getChipVariant(chipType, theme);
    
    return (
      <Chip
        label={status}
        {...chipProps}
        size="small"
        style={{ margin: "0" }}
      />
    );
  };

  const ButtonField = ({ fieldName, fieldTitle }) => {
    return (
      <Typography component={'span'} name={fieldName} onClick={() => HandleLabelPageUrlSelection(fieldName)}>
        {formatMoney(currentObject[fieldName])}
      </Typography>
    )
  };

  const CheckBoxField = ({ fieldName, fieldTitle }) => {
    return (
      <Checkbox
        name={fieldName}
        checked={Boolean(currentObject[fieldName])}
        onClick={(event) => HandleRowPropertyToggled(event)}
        inputProps={{ "aria-labelledby": fieldTitle }}
      />
    )
  };

  const SwitchField = ({ fieldName, fieldTitle }) => {
    return (
      <Switch
        name={fieldName}
        checked={Boolean(currentObject[fieldName])}
        onClick={(event) => HandleRowPropertyToggled(event)}
        inputProps={{ "aria-labelledby": fieldTitle }}
      />
    )
  };
  const ChipField = ({ fieldName, fieldTitle }) => {
    return (
      <Chip
        name={fieldName}
        label={currentObject[fieldName]}
        color="primary"
        inputProps={{ "aria-labelledby": fieldTitle }}
      />
    )
  };
  const Icon = ({ fieldName, fieldTitle, icon }) => {
    return (
      <div>
        {currentObject[fieldName] == 1 &&
          <CheckCircleRoundedIcon
            style={{ fill: "green" }}
          />}
        {currentObject[fieldName] == 0 &&
          <ErrorOutlineIcon
            style={{ fill: "red" }}
          />}
        {currentObject[fieldName] == undefined &&
          <div></div>
        }
      </div>
    )
  };
  const DropDownField = ({ fieldName, fieldTitle, options, optionDisplayProperty, optionOnSelectValue, onChangeMethod }) => {
    // Ensure options is always an array
    const safeOptions = options || [];
    // Ensure value is always defined - Material-UI Select requires a defined value
    // Use empty string if undefined, or check if null is a valid option value
    const fieldValue = currentObject[fieldName];
    const hasNullOption = safeOptions.length > 0 && safeOptions.some(opt => opt && opt[optionOnSelectValue] === null);
    const currentValue = fieldValue !== undefined && fieldValue !== null ? fieldValue : (hasNullOption ? null : "");
    
    // Check for field-level validation errors
    const fieldErrors = currentObject._fieldErrors || {};
    const hasError = fieldErrors[fieldName];
    const errorText = hasError || '';

    return (
      <FormControl variant="outlined" fullWidth size={inputSize} my={2} spacing={0} error={!!hasError}>
        <InputLabel id={"select" + fieldName + passedGlobalIndex + "DropdownField_Label"} shrink>{fieldTitle}</InputLabel>
        <Select
          labelId={"select" + fieldName + passedGlobalIndex + "DropdownField_Label"}
          id={"select" + fieldName + passedGlobalIndex + "DropdownField"}
          value={currentValue ?? ""}
          onChange={(event) => {
            onFieldChange(event);
            if (handleStandardItemChange) {
              handleStandardItemChange(currentObject);
            }
            if(onChangeMethod)
              onChangeMethod(currentObject)
          }}
          name={fieldName}
          label={fieldTitle}
          fullWidth
          displayEmpty
          renderValue={(selected) => {
            if (!selected || selected === '' || selected === null) {
              return <em style={{ color: '#999' }}>Select...</em>;
            }
            const selectedOption = safeOptions.find(opt => opt && opt[optionOnSelectValue] === selected);
            return selectedOption ? (selectedOption[optionDisplayProperty] || "") : selected;
          }}
          sx={{
            '& .MuiSelect-select': {
              display: 'flex',
              alignItems: 'center',
            },
          }}
        >
          {safeOptions.length > 0 ?
            [
              safeOptions.map((option, key) => {
                if (!option) return null;
                const optionValue = option[optionOnSelectValue];
                const optionDisplay = option[optionDisplayProperty];
                // Ensure optionValue is never undefined - use empty string as fallback
                const safeOptionValue = optionValue !== undefined && optionValue !== null ? optionValue : "";
                return (
                  <MenuItem key={key} value={safeOptionValue}>{optionDisplay || ""}</MenuItem>
                )
              }).filter(Boolean)
            ]
            :
            [
              <MenuItem key="no-options" value="">No {fieldTitle} options Found</MenuItem>
            ]
          }
        </Select>
      </FormControl>
    )
  };
  /////////////////////////////////////////////////////////

  /////////////////////////////////////////////////////////
  // Field Selection method:
  const getDesiredField = (field, fieldTitle, fieldType, ddFieldItem, url, model, HandleRowSelected) => {
    switch (fieldType) {
      case "text":
        return (<EditableTextField fieldName={field} fieldTitle={fieldTitle} />);
      case "number":
        return (<EditableNumberField fieldName={field} fieldTitle={fieldTitle} />);
      case "money":
        return (<EditableMoneyField fieldName={field} fieldTitle={fieldTitle} />);
      case "numberFourDecimal":
        return (<EditableNumberFourDecimalLimitField fieldName={field} fieldTitle={fieldTitle} />);
      case "checkBox":
        return (<CheckBoxField fieldName={field} fieldTitle={fieldTitle} />);
      case "switch":
        return (<SwitchField fieldName={field} fieldTitle={fieldTitle} />);
      case "dateLabel":
        return (<TableLblDateField fieldName={field} fieldTitle={fieldTitle} />);
      case "dateLabelNoTime":
        return (<TableLblDateNoTimeField fieldName={field} fieldTitle={fieldTitle} />);
      case "dateField":
        return (<EditableDateField fieldName={field} fieldTitle={fieldTitle} />);

      case "dateTimeLabel":
        return (<TableLblDateTimeField fieldName={field} fieldTitle={fieldTitle} />);
      case "label":
        return (<TableLblField fieldName={field} fieldTitle={fieldTitle} />);
      case "phoneLabel":
        return (<TablePhoneLblField fieldName={field} fieldTitle={fieldTitle} />);
      case "phoneLabelSmall":
        return (<TablePhoneLblFieldSmall fieldName={field} fieldTitle={fieldTitle} />);
      case "labelFourDecimalRounded":
        return (<TableLblFieldFourDecimalRounded fieldName={field} fieldTitle={fieldTitle} />);
      case "labelSmallPageLink":
        return (<TableLblField fieldName={field} fieldTitle={fieldTitle} />);
      case "labelSmallPopupModel":
        return (<TableLblField fieldName={field} fieldTitle={fieldTitle} />);
      case "labelMoneyFourDecimal":
        return (<TableLblMoneyFourDecimal fieldName={field} fieldTitle={fieldTitle} />);
      case "labelSmall":
        return (<TableLblFieldSmall fieldName={field} fieldTitle={fieldTitle} />);
      case "dateLabelSmall":
        return (<TableDateLblFieldSmall fieldName={field} fieldTitle={fieldTitle} />);
      case "dateLabelSmallPopup":
        return (<EditableDateFieldPopupSmall fieldName={field} fieldTitle={fieldTitle} />);
      case "labelBold":
        return (<TableLblFieldBold fieldName={field} fieldTitle={fieldTitle} />);
      case "moneyLabel":
        return (<TableLblMoneyField fieldName={field} fieldTitle={fieldTitle} />);
      case "dropDown":
        return (<DropDownField fieldName={field} fieldTitle={fieldTitle} options={ddFieldItem.values} optionDisplayProperty={ddFieldItem.displayValueName} optionOnSelectValue={ddFieldItem.selectValueName} onChangeMethod={ddFieldItem.onChangeMethod} />);
      case "chip":
        return (<TableLblMoneyField fieldName={field} fieldTitle={fieldTitle} />);
      case "icon":
        return (<Icon fieldName={field} fieldTitle={fieldTitle} />);
      case "buttonLink":
        return (<ButtonLinkField fieldName={field} fieldTitle={fieldTitle} />);
      case "previewBtn":
        return (<PreviewButtonField fieldName={field} fieldTitle={fieldTitle} />);
      case "billPdfBtn":
        return (<BillPdfButtonField fieldName={field} fieldTitle={fieldTitle} />);
      case "sitePlanPdfBtn":
        return (<SitePlanPdfButtonField fieldName={field} fieldTitle={fieldTitle} />);
      case "editBtn":
        return (<EditButtonField fieldName={field} fieldTitle={fieldTitle} />);
      case "resetBatchBillingBtn":
        return (<ResetBatchBillingButtonField fieldName={field} fieldTitle={fieldTitle} />);
      case "workOrderStatus":
        return (<WorkOrderStatusField fieldName={field} fieldTitle={fieldTitle} />);
      case "dateLabelDueDate":
        return (<TableLblDateFieldDueDate fieldName={field} fieldTitle={fieldTitle} />);
      case "complaintSlaChip":
        return (<ComplaintSlaChipField fieldName={field} fieldTitle={fieldTitle} />);
      case "complaintStatusChip":
        return (<ComplaintStatusChipField fieldName={field} fieldTitle={fieldTitle} />);
      case "leaseLightIcon":
        return (<LeaseLightIcon fieldName={field} fieldTitle={fieldTitle} />);
      case "EVMeterIcon":
        return (<EvMeterIcon fieldName={field} fieldTitle={fieldTitle} />);
      case "statusTag":
        return (<StatusTagField fieldName={field} fieldTitle={fieldTitle} />);
      default:
        return (<></>)
    }
  }

  // The row object being returned:
  return (
    <TableRow hover role="checkbox" aria-checked={isItemSelected} tabIndex={-1} key={currentObject.id} selected={isItemSelected} style={conditionalStyle}>
      {!readOnly && <TableCell padding="checkbox">
        <Checkbox
          onClick={(event) => HandleRowSelected(event)}
          checked={isItemSelected}
          inputProps={{ "aria-labelledby": currentObject.id }}
        />
      </TableCell>}
      {showNumber &&
        <TableCell style={{ paddingLeft: "0px" }}>
          #{passedGlobalIndex + 1}
        </TableCell>}
      {
        // Maps each of the objects properties to a respective field.
        // Takes that index and uses it to find what title type and field name is needed for that component
        fieldNames.map((field, index) => {
          //Accessing object value: myObject[key];
          if (!Array.isArray(field)) {
            var fieldTitle = fieldTitles[index];
            const fieldType = fieldTypes[index];
            var ddFieldItem = null;
            if (fieldType == "dropDown") { // If its a dropdown we need to map the propper options array to the field cell:
              ddFieldItem = dropDownFields.find(obj => {
                return obj.targetFieldName === field
              });
            }
            if (hideRowFieldTitles) {
              fieldTitle = null;
            }
            return (<TableCell align="left" key={fieldType + "Cell" + index} onClick={() => handleRowClick(currentObject)} style={conditionalStyle} sx={{ ...(cellVerticalAlign === 'top' ? { verticalAlign: 'top' } : {}), }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: cellVerticalAlign === 'top' ? 'flex-start' : 'center', alignItems: 'stretch', minHeight: inputSize === 'small' ? '40px' : '56px' }}>
                {getDesiredField(field, fieldTitle, fieldType, ddFieldItem)}
              </Box>
            </TableCell>);
          }
          else {
            var ddFieldItem = null;
            var cellComponents = [];
            field.map((childField, childIndex) => {
              var title = fieldTitles[index];
              if (Array.isArray(fieldTitles[index][childIndex])) {
                title = fieldTitles[index][childIndex];
              }
              if (hideRowFieldTitles) {
                title = null;
              }
              cellComponents.push(getDesiredField(childField, title, fieldTypes[index][childIndex], ddFieldItem))
            })
            return (<TableCell className={classes.tableCell} align="left" key={fieldTypes[index] + "Cell" + index} onClick={() => handleRowClick(currentObject)} style={conditionalStyle} sx={cellVerticalAlign === 'top' ? { verticalAlign: 'top' } : {}}>
              <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: cellVerticalAlign === 'top' ? 'flex-start' : 'center', alignItems: 'stretch', minHeight: inputSize === 'small' ? '40px' : '56px' }}>
                {cellComponents.map((component, key) => {
                  return (
                    <Box sx={{ display: 'flex' }} key={key}>
                      {component}
                    </Box>
                  )
                })}
              </Box>
            </TableCell>);
          }
        })
      }
    </TableRow>
  );
}